import { Trash2, FileSpreadsheet } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "./ui/alert-dialog";
import { monthLabel } from "../lib/csvAnalysis";
import { fmtNum, fmtBytes } from "../lib/format";

export const CurrentDataset = ({ meta, onDelete }) => {
  if (meta === undefined) return null;
  return (
    <div className="max-w-5xl mx-auto px-6 pt-12 fade-up">
      <p className="label-mono mb-3">Current dataset</p>
      {meta ? (
        <div className="panel p-5 flex flex-wrap items-center gap-5" data-testid="current-dataset-card">
          <FileSpreadsheet className="h-8 w-8 text-ep-soft" />
          <div className="min-w-0 flex-1">
            <p className="text-slate-100 font-medium truncate" data-testid="current-dataset-name">{meta.fileName}</p>
            <p className="text-xs font-mono text-slate-500 mt-1" data-testid="current-dataset-meta">
              {fmtNum(meta.rowsRead)} rows · {meta.userCount} users · {monthLabel(meta.months[0])} → {monthLabel(meta.months[meta.months.length - 1])}{meta.fileSize ? ` · ${fmtBytes(meta.fileSize)}` : ""} · uploaded {new Date(meta.uploadedAt).toLocaleString()}
            </p>
          </div>
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <button data-testid="delete-dataset-button" className="inline-flex items-center gap-2 text-xs px-3 py-2 rounded-md border border-rose-500/40 text-rose-300 hover:bg-rose-500/10"><Trash2 className="h-3.5 w-3.5" /> Delete</button>
            </AlertDialogTrigger>
            <AlertDialogContent className="bg-[#111827] border-slate-800 text-slate-200">
              <AlertDialogHeader>
                <AlertDialogTitle className="text-slate-100">Delete the current dataset?</AlertDialogTitle>
                <AlertDialogDescription className="text-slate-400">The dashboard will be empty until you upload a new CSV.</AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel data-testid="delete-cancel" className="bg-transparent border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white">Cancel</AlertDialogCancel>
                <AlertDialogAction data-testid="delete-confirm" onClick={onDelete} className="bg-rose-600 hover:bg-rose-500 text-white">Delete</AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      ) : (
        <div className="panel p-5 text-sm text-slate-500" data-testid="no-dataset">No dataset saved yet.</div>
      )}
    </div>
  );
};
